import styles from './GuestLayout.module.scss'
import classNames from 'classnames/bind'
import { Grid, Stack } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import { PATH_NAME } from '~/constants/paths'
import { EFManagerCover, Footer } from './components'
import { EFLoading, JsxChildrenProps } from '~/components'
import { Suspense } from 'react'

import { bgLogin } from '~/assets/images'

const cx = classNames.bind(styles)

export const GuestLayout = ({ children }: JsxChildrenProps) => {
  const location = useLocation()

  return (
    <div className={cx('guest-layout')}>
      <img src={bgLogin} alt='background' className={cx('background-img')} />
      <div className={cx('layout-card')}>
        <Grid className={cx('layout-grid')}>
          {(location.pathname === PATH_NAME.LOGIN_PAGE.path || location.pathname === PATH_NAME.REGISTER_SERIAL_NUMBER_PAGE.path) && (
            <EFManagerCover />
          )}
          <Grid className={cx('content')}>
            <Stack className={cx('content-stack')}>
              {children}
              <Footer />
            </Stack>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
export const GuestLayoutOutlet = () => {
  const location = useLocation()

  return (
    <div className={cx('guest-layout')}>
      <img src={bgLogin} alt='background' className={cx('background-img')} />
      <div className={cx('layout-card')}>
        <Grid className={cx('layout-grid')}>
          {(location.pathname === PATH_NAME.LOGIN_PAGE.path ||
            location.pathname === PATH_NAME.REGISTER_SERIAL_NUMBER_PAGE.path ||
            location.pathname === PATH_NAME.PROVIDER_LOGIN_PAGE.path) && <EFManagerCover />}
          <Grid className={cx('content')}>
            <Stack className={cx('content-stack')}>
              <Suspense fallback={<EFLoading isFixed />}>
                <Outlet />
              </Suspense>
              <Footer />
            </Stack>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
